import { Skeleton, Card, Col, Row } from "antd";
import { FC } from "react";
import favIconUrl from "assets/Images/SkeltonCardLogo.svg";
import LazyLoadImage from "../LazyLoadImage";

interface SkeletonCardProps {
  count: number;
  loading: boolean;
  children: any;
  customGutter: any;
  rowCount?: number;
}

const NewsCartSkelton: FC<SkeletonCardProps> = ({
  count = 1,
  loading = false,
  children,
  customGutter,
  rowCount = 1,
}) => {
  if (!loading) return children;

  const totalCards = count * rowCount;
  const columnsPerRow = Math.round(24 / count);

  return (
    <>
      {[...Array(rowCount)].map((_, rowIndex) => (
        <Row gutter={customGutter} key={rowIndex}>
          {[...Array(count)].map((_, colIndex) => {
            const keyIndex = rowIndex * count + colIndex;
            return (
              <Col xs={24} sm={12} lg={6} key={keyIndex}>
                <Card className="rounded-lg mb-4">
                <div className="!bg-[#f0f0f0] !w-full !h-[200px] !flex justify-center items-center ">
                        <div className="!w-[70px] !h-[70px] !rounded-full !bg-[#FFEDCC] !flex items-center justify-center" >

                          <div className="!w-[40px] !h-[40px] loader" ></div>
                        </div>
                     
                      </div>
                  <div className="p-4">
                    <Skeleton active title={{ width: "80%" }} paragraph={{ rows: 1, width: ["100%"] }} />
                    <Skeleton active paragraph={{ rows: 3, width: ["100%", "90%", "80%"] }} />
                  </div>
                </Card>
              </Col>
            );
          })}
        </Row>
      ))}
    </>
  );
};

export default NewsCartSkelton;
